import React from 'react';

import { RemoteAgentPresenceIcon } from '~src/settings/bridge-settings/sections/bridgeRemoteAgents/RemoteAgentPresenceIcon';
import { IRemoteAgentConnectionStatus } from '~src/settings/bridge-settings/serverApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';

import { getRemoteAgentStates } from './RemoteAgentStates';

export function BridgeRemoteAgentsPresenceIcon(agent: IRemoteQueryAgent, remoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[], poolTestId: string) {
  return (
    <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'agent-connection-status-cell' + poolTestId}>
      {renderRemoteAgentPresenceIcon(agent, remoteAgentConnectionStatuses)}
    </span>
  );
}

function renderRemoteAgentPresenceIcon(agent: IRemoteQueryAgent, remoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[]) {
  if (remoteAgentConnectionStatuses.length !== 0) {
    const status = getAgentStatus(agent, remoteAgentConnectionStatuses);
    const remoteAgentStates = getRemoteAgentStates();

    if (status !== null) {
      return (<>
        <RemoteAgentPresenceIcon status={status.connectionStatus} remoteAgentStates={remoteAgentStates} />
        {remoteAgentStates[status.connectionStatus].stateLabel}
      </>);
    }
  }

  return null;
}

export function getAgentStatus(agent: IRemoteQueryAgent, remoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[]): IRemoteAgentConnectionStatus {
  for (let i = 0; i < remoteAgentConnectionStatuses.length; i++) {
    if (remoteAgentConnectionStatuses[i].agentName === agent.agentName) {
      return remoteAgentConnectionStatuses[i];
    }
  }
  return null;
}
